import { Trash3Fill, X } from "react-bootstrap-icons";
// import './DeleteModal.scss';
import { Fragment, useRef, useState } from 'react'
import { BsPlusCircle, BsQuestionCircle } from 'react-icons/bs'
import { HiOutlineChevronDown } from 'react-icons/hi'
import { Dialog, Transition } from '@headlessui/react'
import { IoWarningOutline } from 'react-icons/io5'
import { FiCheck } from "react-icons/fi"
import { IoAlert } from "react-icons/io5"

interface PropData {
    show: any;
    isClose: any;
    message: any;
    isShowButton?: any;
    isHtml?: boolean;
}

const WarningModal = (props: PropData) => {
    const [open, setOpen] = useState(true)
    const cancelButtonRef = useRef(null)

    const handleClose = () => {
        // setOpen(false)
        props.isClose();
    };
    const OnDelete = () => {
        // setOpen(false)
        props.message();
    };
    return (
        <div>
            {props.show &&
                // <div className="modal">
                //   <div className="modal-content">
                //     <div className="modal-cross">
                //       <X size={30} onClick={handleClose} />
                //     </div>
                //     <p className="modal-alert-text">Alert!</p>
                //     <p className="modal-heading">Are you sure you want to delete?</p>
                //     <div className="flex mt-6  text-center justify-center">
                //       <div className="modal-cancel-button" onClick={handleClose}>
                //         Cancel
                //       </div>
                //       <div className="modal-delete-button" onClick={OnDelete}>
                //         <Trash3Fill size={17} style={{ marginRight: 5 }} />
                //         Delete
                //       </div>
                //     </div>
                //   </div>
                // </div>

                <Transition.Root show={open} as={Fragment}>
                    <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                >
                                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                                        <div>
                                            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                                                <IoAlert className="h-6 w-6 text-red-700" aria-hidden="true" />
                                            </div>
                                            <div className="mt-3 text-center sm:mt-5">
                                                <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-red-500">
                                                    Warning
                                                </Dialog.Title>
                                                <div className="mt-2">

                                                    <p className="text-sm text-gray-500">
                                                        {props.isHtml == true ? <div dangerouslySetInnerHTML={{ __html: props.message }} /> : props.message}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            !props.isShowButton &&
                                            <div className="mt-5 sm:mt-6">
                                                <button
                                                    type="button"
                                                    className="inline-flex w-full justify-center rounded-md bg-brand px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                    // onClick={() => setOpen(false)}
                                                    onClick={handleClose}
                                                >
                                                    Go back
                                                </button>
                                            </div>
                                        }
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            }
        </div>
    );
};

export default WarningModal;
